import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import student from "./views/StartEnd/student";
Vue.use(Router)

const router = new Router({
  mode: 'history', //Funkar men kanske inte bra?
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/homeadmin',
      name: 'Hem',
      component: () => import('./views/HomeAdmin.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/homeeht',
      name: 'HemEHT',
      // component: Home
      component: () => import('./views/HomeEHT.vue'),

    },
    {
      path: '/end',
      name: 'End',
      component: () => import('./views/whistle.vue'),
      // component: student
      // component: () => import('./views/StartEnd/student.vue'),

    },
    {
      path: '/end/:nurseId',
      name: 'end',
      // component: student,
      props: true,
      component: () => import('./views/StartEnd/end.vue'),

    },
    {
      path: '/startschool/:nurseId',
      name: 'school',
      // component: Home
      props: true,
      component: () => import('./views/StartEnd/school.vue'),
    },
    // {
    //   //  path: '/whistle/:schoolId',
    //   path: '/veva',
    //   name: 'whistle',
    //    props: true,
    //   component: () => import('./views/whistle.vue'),
    // },
    {
      //  path: '/whistle/:schoolId',
      path: '/whistle',
      name: 'whistle',
       props: true,
      // component: () => import('./views/whistle.vue'),
      component: () => import('./views/externcentral.vue'),
    },
    {
      path: '/feeling',
      name: 'feeling',
       props: true,
      component: () => import('./views/feeling.vue'),
    },
    {
      path: '/krank',
      name: 'krank',
      //  props: true,
       component: () => import('./views/krank.vue'),
    },
    {
      path: '/extern',
      name: 'ex',
      //  props: true,
       component: () => import('./views/whistle.vue'),
    },
    {
      path: '/student/:nurseId',
      name: 'student',
      // component: Home
      props: true,
      component: student,
    },
    {
      path: '/hometeacher',
      name: 'HemTeacher',
      
      component: () => import('./views/HomeTeacher.vue'),
      // component: () => import('./views/HomeAdmintest.vue'),
      // meta: {
      //   requiresAuth: true
      // }
    },
    // {
    //   path: '/hometester',
    //   name: 'Hemtester',
    //   component: () => import('./views/HomeAdmintest.vue'),
    //   // meta: {
    //   //   requiresAuth: true
    //   // }
    // },
    // {
    //   path: "/classrooms/:classroomId",
    //   name: "Classroom",
    //   component: Classroom,
    //   meta: {
    //     requiresAuth: true
    //   },
    //   props: true
    // },
    // {
    //   path: "/student/:classroomId",
    //   name: "student",
    //   component: Student,
    //   props: true
    // },
    {
      path: '/login',
      name: 'login',
      // component: Home
      component: () => import('./views/login/index.vue')
    }
    // {
    //   path: '/teacher',
    //   name: 'teacher',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('./views/teacher.vue')
    // },
    // {
    //   path: '/firestore-db',
    //   name: 'firestore-db',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import('./views/appDB.vue')
    // },
    // {
    //   path: '/firebase-auth',
    //   name: 'firebase-auth',
    //   component: () => import('./views/appAuth.vue')
    // }
  ]
})
router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !currentUser) next('/login?to=${to.path}')
  else if (!requiresAuth && currentUser) next('/homeAdmin')
  else next()
})
export default router
